import { DatePicker as AntDatePicker } from 'antd';
import deDE from 'antd/es/date-picker/locale/de_DE';
import locale from 'antd/es/date-picker/locale/en_US';
import esES from 'antd/es/date-picker/locale/es_ES';
import fiFI from 'antd/es/date-picker/locale/fi_FI';
import frFR from 'antd/es/date-picker/locale/fr_FR';
import itIT from 'antd/es/date-picker/locale/it_IT';
import nlNL from 'antd/es/date-picker/locale/nl_NL';
import svSE from 'antd/es/date-picker/locale/sv_SE';
import { DatePickerProps, RangePickerProps } from 'antd/lib/date-picker';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import {
  BackgroundColor,
  getBackgroundColor,
  InputBorder,
  InputFocus,
  NewInputBorder,
  NewInputFocus,
} from 'components/atoms/input/input';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { useLocale } from 'hooks/use-language-select';

const localeMap = {
  en: locale,
  de: deDE,
  es: esES,
  fr: frFR,
  it: itIT,
  nl: nlNL,
  fi: fiFI,
  sv: svSE,
};

export const Picker = forwardRef<any, DatePickerProps>((props, ref) => {
  const { locale: currentLocale } = useLocale();
  const datePickerLocale =
    localeMap[currentLocale?.toLowerCase() || 'en'] || localeMap.en;

  return (
    <AntDatePicker
      ref={ref}
      format={DATE_INPUT_DISPLAY_FORMAT}
      {...props}
      locale={datePickerLocale}
    />
  );
});

Picker.displayName = 'DatePicker';

export const DatePicker = styled(Picker)<DatePickerProps>`
  ${InputBorder};
  ${BackgroundColor};
  padding: 0 var(--spacing-05);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
  &.ant-picker-focused {
    ${InputFocus};
  }
`;

const { RangePicker } = AntDatePicker;

const NewUIDateRangePicker = styled(RangePicker)<RangePickerProps>`
  background-color: ${getBackgroundColor(true)};
  ${NewInputBorder};
  padding: var(--spacing-02) var(--spacing-05);
  height: var(--height-base);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
  &.ant-picker-focused {
    ${NewInputFocus};
  }
`;

const StyledDateRangePicker = styled(RangePicker)<RangePickerProps>`
  ${InputBorder};
  ${BackgroundColor};
  padding: 0 var(--spacing-05);
`;

export const DateRangePicker = forwardRef<any, RangePickerProps>(
  (props, ref) => {
    const isNewDesignEnabled = useAntdRlUISwitcher();

    if (isNewDesignEnabled) {
      return <NewUIDateRangePicker {...props} ref={ref} />;
    }

    return <StyledDateRangePicker {...props} ref={ref} />;
  },
);

export const DefaultRangePicker = RangePicker;
